<div class="top">
    <div>
        <!-- <div class="headship">
            <h1 align="center">Shipping</h1>
        </div> -->
        <!-- <div class="vc_empty_space" style="height: 30px;"><span class="vc_empty_space_inner"></span>
        </div> -->
       
        <div class="vc_empty_space" style="height: 5px;"><span
                class="vc_empty_space_inner"></span>
        </div>
        <div class="shipping">
            <!-- <h4 style="margin: 0 0 15px 20px;color: #FFD636;">Shipping Calculator</h4> -->
            <div class="container-fluid">
                <form [formGroup]="shippingForm"
                    (ngSubmit)="getShippingRates()">
                    <div class="row">
                        <div class="col-md-12 col-lg-12 col-xl-12">
                            <div class="card">
                                <div class="card-header">
                                    <h5 align="center">Calculate Rates</h5>
                                </div>
                                <div class="card-body">
                                    <div class="row col-xs-12 col-sm-12
                                        col-md-12">
                                        <div class="col-xs-12 col-sm-4
                                            col-md-4">
                                            <label>From Country/Territory</label><br>
                                            <select id="selectcountry">
                                                <!-- <option>Select Country</option> -->
                                                <option selected>India</option>
                                            </select>

                                            <!-- <label>To Country/Territory*</label><br>
                                            <select id="selectcountry"
                                                formControlName="ZoneNumber">
                                                <option value=""
                                                    *ngIf="selectCountry">Select
                                                    Country</option>
                                                <option value=""
                                                    *ngIf="!selectCountry">Select
                                                    Country</option>
                                                <option *ngFor="let country of
                                                    CountryZones"
                                                    [value]="country.ZoneNumber">
                                                    {{ country.CountryName }}
                                                </option>
                                            </select> -->
                                            <br><br>
                                        </div>
                                        <div class="col-xs-12 col-sm-4
                                            col-md-4">
                                            <!-- <label>City</label><br>
                                            <input type="text"
                                                placeholder="City" size="20"> -->
                                            <!-- <img src="assets\Images\Group 1117.png" height="18" width="20"
                                                style="margin-left: 15px;"> -->
                                            <!-- <br><br> -->
                                            <!-- <label>City</label><br>
                                            <input type="text"
                                                placeholder="City" size="20"><br><br> -->
                                        </div>
                                        <div class="col-xs-12 col-sm-4
                                            col-md-4">
                                            <!-- <label>Postal Code</label><br>
                                            <input type="text" size="20"
                                                placeholder="postal code"> -->
                                            <!-- <br><br> -->
                                            <!-- <label>Postal Code</label><br>
                                            <input type="text" size="20"
                                                placeholder="postal code"> -->
                                        </div>
                                    </div>
                                    <div class="row col-xs-12 col-sm-12
                                        col-md-12">
                                        <div class="col-xs-12 col-sm-4
                                            col-md-4">
                                            <!-- <label>From Country/Territory</label><br>
                                            <select id="selectcountry">
                                              
                                                <option selected>India</option>
                                            </select>
                                            <br><br> -->
                                            <label>Destination
                                                Country/Territory*</label><br>
                                            <select id="selectcountry"
                                                formControlName="ZoneNumber">
                                                <option value=""
                                                    *ngIf="selectCountry">Select
                                                    Country</option>
                                                <option value=""
                                                    *ngIf="!selectCountry">Select
                                                    Country</option>
                                                <option *ngFor="let country of
                                                    CountryZones"
                                                    [value]="country.ZoneNumber">
                                                    {{ country.CountryName }}
                                                </option>
                                            </select>
                                            <br><br>
                                        </div>
                                        <div class="col-xs-12 col-sm-4
                                            col-md-4">
                                            <!-- <label>City</label><br>
                                            <input type="text"
                                                placeholder="City" size="20"> -->
                                            <!-- <img src="assets\Images\Group 1117.png" height="18" width="20"
                                                style="margin-left: 15px;"> -->
                                            <label>Destination City</label><br>
                                            <input type="text"
                                                placeholder="City" size="20"><br><br>
                                        </div>
                                        <div class="col-xs-12 col-sm-4
                                            col-md-4">
                                            <!-- <label>Postal Code</label><br>
                                            <input type="text" size="20"
                                                placeholder="postal code"> -->
                                            <label>Destination Postal Code</label><br>
                                            <input type="text" size="20"
                                                placeholder="postal code">
                                        </div>
                                    </div>
                                    <br>
                                    <div class="row col-xs-12 col-sm-12
                                        col-md-12">
                                        <div class="col-xs-12 col-sm-12
                                            col-md-12">
                                            <label>Weight(kgs)*</label><br>
                                            <input type="number" min="0"
                                                size="12" id="abc" step="1.0"
                                                formControlName="WeightKgs"   >
                                            &nbsp;
                                            <!-- <div class="form-check-inline"
                                                style="margin-top: 5px;">
                                                <label
                                                    class="form-check-label1">
                                                    <input type="radio"
                                                        class="form-check-input"
                                                        name="weightType"
                                                        value="kgs"
                                                        formControlName="weightType">kgs
                                                  
                                                </label>
                                            </div>
                                            <div class="form-check-inline">
                                                <label class="form-check-label">
                                                    <input type="radio"
                                                        class="form-check-input"
                                                        name="weightType"
                                                        value="lbs"
                                                        formControlName="weightType">lbs
                                                </label>
                                            </div> -->
                                            <br><br>
                                            <b style="font-size: 18px;">Optional
                                                Fields</b><br>
                                            <div style="border: 1px solid
                                                grey;padding: 10px 10px;width:
                                                90%;" class="row col-xs-12 col-sm-12 col-md-12">
                                                <div class="col-xs-4 col-sm-4 col-md-4">
                                                    <label>Length(cm)</label><br>
                                                    <input type="number" min="0"
                                                        size="12"
                                                        formControlName="length"
                                                        placeholder="Optional">
                                                    <br><br>
                                                    <label>Width(cm)</label><br>
                                                    <input type="number" min="0"
                                                        size="12"
                                                        formControlName="width"
                                                        placeholder="Optional"><br><br>
                                                    <label>Height(cm)</label><br>
                                                    <input type="number" min="0"
                                                        size="12"
                                                        formControlName="height"
                                                        placeholder="Optional">
                                                </div>
                                                
                                                <div class="col-sm-8 col-md-8">
                                                    <h6 align="left"
                                                    style="margin-left: 30px;">Package
                                                    size sample</h6>
                                                    <!-- <img src="assets\Images\Group 909.png" width="280"
                                                    height="200"> -->
                                                    <img
                                                        src="assets\Images\volume_weightbox.png"
                                                        id="diamensionbox">
                                                </div>
                                            </div>

                                            <!-- <p><img src="assets\Images\circle.png" height="18" width="20">&nbsp;No account? No
                                               Problem! Pay with Credit card or Cash
                                           </p>
                                           <p><img src="assets\Images\circle.png" height="18" width="20">&nbsp;View packaging and
                                               delivery options
                                           </p>
                                           <p><img src="assets\Images\circle.png" height="18" width="20">&nbsp;View packaging and
                                               delivery options
                                           </p> -->
                                        </div>
                                        <!-- <div class="col-xs-12 col-sm-7
                                            col-md-7">
                                            <br>
                                            <h6 align="left" style="margin-left: 30px;">Package size sample</h6>
                                            <div>
                                            
                                               
                                                    <img src="assets\Images\volume_weightbox.png" width="350"
                                                    height="250">
                                            </div>
                                            <br>
                                            <label>Length(cm)</label><br>
                                           <input type="number" min="0" size="12" id="abc">&nbsp;
                                           <br><br>
                                           <label>Width(cm)</label><br>
                                           <input type="number" min="0" size="12"><br><br>
                                           <label>Height(cm)</label><br>
                                           <input type="number" min="0" size="12">
                                            <div class="center1">
                                               <a href=""><button class="btn" type="submit">Get Shipping
                                                       Rates</button></a>
                                           </div>
                                        </div> -->
                                    </div>
                                    <div class="center1">
                                        <a href=""><button class="btn"
                                                type="submit">Get Rates</button></a>
                                    </div>
                                </div>
                            </div>
                            <!-- <p align="right">Packing weight , volumetric weight
                                will be calculated Finally</p> -->
                        </div>

                        <!-- <div class="col-md-6 col-lg-6 col-xl-3 text-center">
                           <label>cm and in Conversion mode</label>
                           <p>1 cm = 0.3937 in (1 in = 2.54 cm)</p>
                           <br>
                           <label>Kg and lbs Conversion mode</label>
                           <p>1 lbs = 0.4536 Kg (1 Kg = 2.2046 lbs)</p>
                           <br>
                           <label>Package size sample</label>
                           <div>
                               <br>
                               <img src="assets\Images\Group 909.png" width="270" height="200">
                           </div>
                           <br>
                        </div> -->
                    </div>
                </form>
            </div>
            <!-- <div class="container-fluid">
                  <form [formGroup]="shippingForm" (ngSubmit)="getShippingRates()">
                    <div class="row">
                        <div class="col-md-6 col-lg-6 col-xl-8">
                           <div class="card">
                               <div class="card-header">
                                   <h5 align="center">Estimate you Shipping Cost</h5>
                               </div>
                               <div class="card-body">
                                   <div class="row col-xs-12 col-sm-12 col-md-12">
                                       <div class="col-xs-12 col-sm-4 col-md-4">
                                           <label>Country/Territory</label><br>
                                          
                                           <select id="selectcountry">
                                               
                                               <option selected>India</option>
                                           </select>
                                           <br><br>
                                           <label>Country/Territory</label><br>
                                          
                                           <select id="selectcountry" formControlName="ZoneNumber">
                                               <option value="" *ngIf="selectCountry">Select Country</option>
                                               <option value="" *ngIf="!selectCountry">Select Country</option>
                                               <option *ngFor="let country of CountryZones" [value]="country.ZoneNumber"> {{ country.CountryName }} </option>
                                           </select>
                                           <br><br>
                                       </div>
                                       <div class="right col-xs-12 col-sm-8 col-md-8">
                                           <label>From</label><br>
                                           <input type="text" placeholder="Street address, City, Postal code, Country... ">
                                           <img src="assets\Images\Group 1117.png" height="18" width="20"
                                               style="margin-left: 15px;">
                                           <br><br>
                                           <label>To</label><br>
                                           <input type="text" placeholder="Street address, City, Postal code, Country... ">
                                       </div>
                                   </div>
                                   <br>
                                   <div class="row col-xs-12 col-sm-12 col-md-12">
                                       <div class="col-xs-12 col-sm-6 col-md-6">
                                           <label>Weight</label><br>
                                           <input type="number" min="0" size="12" id="abc" formControlName="WeightKgs">&nbsp;
                                           <div class="form-check-inline">
                                               <label class="form-check-label1">
                                                   <input type="radio" class="form-check-input" name="optradio1">kgs
                                               </label>
                                           </div>
                                           <div class="form-check-inline">
                                               <label class="form-check-label">
                                                   <input type="radio" class="form-check-input" name="optradio1">lbs
                                               </label>
                                           </div>
                                           <br><br><br>
                                         
                                           <p><img src="assets\Images\circle.png" height="18" width="20">&nbsp;No account? No
                                               Problem! Pay with Credit card or Cash
                                           </p>
                                           <p><img src="assets\Images\circle.png" height="18" width="20">&nbsp;View packaging and
                                               delivery options
                                           </p>
                                           <p><img src="assets\Images\circle.png" height="18" width="20">&nbsp;View packaging and
                                               delivery options
                                           </p>
                                       </div>
                                       <div class="col-xs-12 col-sm-6 col-md-6">
                                           <label>Length</label><br>
                                           <input type="number" min="0" size="12" id="abc">&nbsp;
                                           <div class="form-check-inline">
                                               <label class="form-check-label">
                                                   <input type="radio" class="form-check-input" name="optradio">cm
                                               </label>
                                           </div>
                                           <div class="form-check-inline">
                                               <label class="form-check-label">
                                                   <input type="radio" class="form-check-input" name="optradio">in
                                               </label>
                                           </div>
                                          
                                           <br><br>
                                           <label>Width</label><br>
                                           <input type="number" min="0" size="12"><br><br>
                                           <label>Height</label><br>
                                           <input type="number" min="0" size="12">
                                           <div class="center1">
                                               <a href=""><button class="btn" type="submit">Get Shipping
                                                       Rates</button></a>
                                           </div>
                                       </div>
                                   </div>
                               </div>
                           </div>
                           <p align="right">Packing weight , volumetric weight will be calculated Finally</p> 
                        </div>
       
                        <div class="col-md-6 col-lg-6 col-xl-4">
                           <label>cm and in Conversion mode</label>
                           <p>1 cm = 0.3937 in (1 in = 2.54 cm)</p>
                           <br>
                           <label>Kg and lbs Conversion mode</label>
                           <p>1 lbs = 0.4536 Kg (1 Kg = 2.2046 lbs)</p>
                           <br>
                           <label>Package size sample</label>
                           <div>
                               <br>
                               <img src="assets\Images\Group 909.png" width="270" height="200">
                           </div>
                           <br>
                        </div>
                     </div>
                  </form>
              </div> -->
        </div>
        <!-- <div class="services">
            <h4 align="center">Services we offer</h4>
            <div class="row col-xs-12 col-sm-12 col-md-12">
                <div class="col-xs-12 col-sm-2 col-md-2"></div>
                <div class="col-xs-12 col-sm-3 col-md-3">
                    <p><img src="assets\Images\Group 1117.png" height="20" width="20">&nbsp;You Buy We Ship</p>
                    <p><img src="assets\Images\Group 1117.png" height="20" width="20">&nbsp;Package Pickup</p>
                </div>
                <div class="col-xs-12 col-sm-3 col-md-3">
                    <p><img src="assets\Images\Group 1117.png" height="20" width="20">&nbsp;Personal Shopper</p>
                    <p><img src="assets\Images\Group 1117.png" height="20" width="20">&nbsp;Shipment Protection</p>
                </div>
                <div class="col-xs-12 col-sm-3 col-md-3 mb-5">
                    <p><img src="assets\Images\Group 1117.png" height="20" width="20">&nbsp;Personal Shopper</p>
                    <p><img src="assets\Images\Group 1117.png" height="20" width="20">&nbsp;Medicines From India</p>
                </div>
            </div>
        </div> -->

        <!-- <div class="box" style="margin-top: 30px;">
            <div style="padding: 25px;">
                <h4 align="center"><b>India post low cost shipping calculator</b></h4>
                <p align="center">Click here to to know </p>
                <div class="test_view_more_btn_container text-center"
                    style="margin-top:-30px;">
                    <button class="test_view_more_btn" (click)="knowmore()">KNOW
                        MORE</button>
                </div>
            </div>
        </div> -->

        
        


        <!-- <div class="testmonial-bg">
            <div class="testimonial_container">
                <div class="testmonial_info">
                    <h3 class="testimonial_title text-center"> What our
                        customers say About us </h3>

                    <div class="container">
                        <div class="row">
                            <div class="col-md-6 col-lg-6 col-xl-4
                                test_one_card">
                                <div class="card">
                                    <div class="card-body">
                                        <h5 class="text-center">
                                            <i class="fa fa-quote-left"
                                                aria-hidden="true" style="color:
                                                #FBBC5D;"></i>
                                        </h5>
                                        <p class="test_para">Contrary to popular
                                            belief, Lorem Ipsum is not simply
                                            random text. It has roots in a piece
                                            of
                                            classical Latin.</p>
                                        <hr class="test_hr">
                                        <div id="uicon">
                                            <img src="assets\Images\Rectangle 50.png" width="70" height="70"
                                                class="rounded-circle"
                                                style="display: block;
                                                margin-left: auto; margin-right:
                                                auto; margin-bottom: 5px;">
                                        </div>
                                        <h5 class="text-center test_name">Gopinath
                                            Appam</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6 col-xl-4
                                test_two_card">
                                <div class="card">
                                    <div class="card-body">
                                        <h5 class="text-center">
                                            <i class="fa fa-quote-left"
                                                aria-hidden="true" style="color:
                                                #FBBC5D;"></i>
                                        </h5>
                                        <p class="test_para">Contrary to popular
                                            belief, Lorem Ipsum is not simply
                                            random text. It has roots in a piece
                                            of
                                            classical Latin.</p>
                                        <hr class="test_hr">
                                        <div id="uicon">
                                            <img src="assets\Images\Rectangle 50.png" width="70" height="70"
                                                class="rounded-circle"
                                                style="display: block;
                                                margin-left: auto; margin-right:
                                                auto; margin-bottom: 5px;">
                                        </div>
                                        <h5 class="text-center test_name">Gopinath
                                            Appam</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6 col-xl-4
                                test_three_card">
                                <div class="card">
                                    <div class="card-body">
                                        <h5 class="text-center">
                                            <i class="fa fa-quote-left"
                                                aria-hidden="true" style="color:
                                                #FBBC5D;"></i>
                                        </h5>
                                        <p class="test_para">Contrary to popular
                                            belief, Lorem Ipsum is not simply
                                            random text. It has roots in a piece
                                            of
                                            classical Latin.</p>
                                        <hr class="test_hr">
                                        <div id="uicon">
                                            <img src="assets\Images\Rectangle 50.png" width="70" height="70"
                                                class="rounded-circle"
                                                style="display: block;
                                                margin-left: auto; margin-right:
                                                auto; margin-bottom: 5px;">
                                        </div>
                                        <h5 class="text-center test_name">Gopinath
                                            Appam</h5>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="test_view_more_btn_container text-center">
                            <button class="test_view_more_btn"
                                (click)="comment()"> View more </button>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <!-- <div style="padding: 40px;">
            <div class="test_view_more_btn_container"
                style="margin-top:-30px;">
                <button class="test_view_more_btn" (click)="payment()">Payment</button>

            </div>
        </div> -->
        <!-- <app-footer></app-footer> -->
    </div>
</div>
